import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  tab: {
    fontSize: 14,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  }
});

export default useStyles;
